import { emptyGUID } from "components/Admin/Organizations/OrganizationDetail/OrganizationModules/OrganizationModuleDetails/OrganizationModuleQuestionDependencies";
import { useNavigate } from "react-router-dom";
import { useStore } from "utils/useStore";
import AgentStore from "../Stores/AgentStore";

// The KboSettingsLayout "Back to KBo" link restores the active chat when the
// user leaves Client Brain settings.
export function useKboSettingsReturn() {
    const navigate = useNavigate();
    const agentStore = useStore(AgentStore);

    return () => {
        const chatId = agentStore.currentChatId;
        navigate(
            "/app/kbo/chats" +
                (chatId && chatId !== emptyGUID ? `/${chatId}` : ""),
        );
    };
}
